import { Observable, Subscriber } from "rxjs";


declare type FileUploadState = 'done' | 'progress' | 'error';

export declare type FileUploadFunc = (file: File) => Observable<FileUploadInfo>;

export interface FileUploadInfo {
    state: FileUploadState;
    percentage: number;
    httpStatusCode: number;
    errorMessage?: string;
    fileId?: number;
}


const handleResult = (req: XMLHttpRequest, observer: Subscriber<FileUploadInfo>) => {

    const result: FileUploadInfo = {
        state: 'done',
        percentage: 100,
        httpStatusCode: req.status,
    }

    if (req.status == 200) {
        result.fileId = JSON.parse(req.responseText);
    } else {
        result.state = 'error';
        result.errorMessage = 'Soubor se nepodařilo odeslat.';
    }


    observer.next(result);
    observer.complete();
}

const handleProgress = (req: XMLHttpRequest, percentage: number, observer: Subscriber<FileUploadInfo>) => {
    const result: FileUploadInfo = {
        state: 'progress',
        percentage: percentage,
        httpStatusCode: req.status,
    }
    observer.next(result);
}

const handleError = (req: XMLHttpRequest, message: string, observer: Subscriber<FileUploadInfo>) => {
    const result: FileUploadInfo = {
        state: 'error',
        percentage: 100,
        httpStatusCode: req.status,
        errorMessage: message,
    }
    observer.next(result);

    observer.error(message);
}

export default (url: string, file: File): Observable<FileUploadInfo> => {

    return new Observable(observer => {
        const formData = new FormData();
        formData.append("file", file, file.name);

        const req = new XMLHttpRequest();

        handleProgress(req, 0, observer); // start uploading

        req.onload = evt => handleResult(req, observer);

        req.upload.addEventListener('progress', evt => handleProgress(req, (evt.loaded / evt.total) * 100, observer), false)

        req.onerror = evt => handleError(req, 'Failed to make request.', observer);

        req.ontimeout = evt => handleError(req, 'Request took longer than expected.', observer);

        req.open("POST", url, true);
        req.send(formData);
    });
}
